// ============================================================================
// src/shared/config/crypto.ts
// Punto único de la clave de cifrado AES (crypto-js). Se lee desde env.ts, que la
// toma del .env (REACT_APP_CRYPTO_KEY). Sin valores hardcodeados (config v1 eliminada).
// ============================================================================
import { env } from "./env";

export const keyCrypto = env.cryptoKey;

export default keyCrypto;
